import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useT } from "../lib/i18n";

const NAV_KEYS = [
  { to: "/", key: "home" },
  { to: "/properties", key: "properties" },
  { to: "/zones", key: "zones" },
  { to: "/services", key: "services" },
  { to: "/market-analytics", key: "market" },
  { to: "/about", key: "about" },
  { to: "/contact", key: "contact" },
];

export default function Navbar() {
  const [open, setOpen] = React.useState(false);
  const { lang, setLang, t } = useT();

  const toggleLang = () => setLang(lang === "en" ? "ar" : "en");

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-zinc-200"
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 flex items-center justify-between h-16">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-2.5"
        >
          <img
            src="/warehousesuae-icon-navy.png"
            alt="WarehousesUAE"
            className="w-10 h-10 object-contain"
            width="40"
            height="40"
          />
          <div className="leading-tight">
            <div className="font-display text-[15px] tracking-tighter">WAREHOUSESUAE<span className="text-[#FFCC00]">.COM</span></div>
            <div className="font-mono-tech text-[9px] text-zinc-500 uppercase">powered by Blueworld Realestate</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV_KEYS.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-${n.key}`}
              className={({ isActive }) =>
                `font-mono-tech text-xs px-3 py-2 border-b-2 transition-colors ${
                  isActive
                    ? "border-[#031833] text-zinc-900"
                    : "border-transparent text-zinc-600 hover:text-zinc-900"
                }`
              }
            >
              {t(`nav.${n.key}`)}
            </NavLink>
          ))}
          <NavLink
            to="/list-your-asset"
            data-testid="nav-list_asset"
            className={({ isActive }) =>
              `font-mono-tech text-xs px-3 py-2 border-b-2 transition-colors ${
                isActive ? "border-[#FFCC00] text-zinc-900" : "border-transparent text-[#031833] hover:text-zinc-900"
              }`
            }
          >
            ★ {t("nav.list_asset")}
          </NavLink>
        </nav>

        <div className="flex items-center gap-2">
          <button
            data-testid="nav-lang-toggle"
            onClick={toggleLang}
            className="font-mono-tech text-xs px-2 py-2 border border-zinc-300 hover:border-zinc-900 hover:bg-zinc-900 hover:text-white"
            aria-label="Toggle language"
          >
            {lang === "en" ? "AR ع" : "EN"}
          </button>
          <a
            href="tel:+971588320669"
            data-testid="nav-call-btn"
            className="hidden md:inline-flex items-center gap-2 font-mono-tech text-xs px-3 py-2 border border-zinc-900 hover:bg-zinc-900 hover:text-white transition-colors"
          >
            <span className="w-1.5 h-1.5 bg-[#22C55E] inline-block"></span>
            +971 58 832 0669
          </a>
          <Link
            to="/properties"
            data-testid="nav-browse-btn"
            className="hidden md:inline-flex bg-[#031833] text-white font-mono-tech text-xs px-4 py-2 hover:bg-[#0A2455]"
          >
            {t("nav.browse")} →
          </Link>
          <button
            data-testid="nav-mobile-toggle"
            className="lg:hidden p-2 border border-zinc-200"
            onClick={() => setOpen(!open)}
          >
            <span className="block w-5 h-0.5 bg-zinc-900 mb-1"></span>
            <span className="block w-5 h-0.5 bg-zinc-900 mb-1"></span>
            <span className="block w-5 h-0.5 bg-zinc-900"></span>
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-zinc-200 bg-white">
          {NAV_KEYS.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              onClick={() => setOpen(false)}
              className="block font-mono-tech text-sm px-4 py-3 border-b border-zinc-100"
            >
              {t(`nav.${n.key}`)}
            </NavLink>
          ))}
          <NavLink
            to="/list-your-asset"
            onClick={() => setOpen(false)}
            className="block font-mono-tech text-sm px-4 py-3 border-b border-zinc-100 text-[#031833]"
          >
            ★ {t("nav.list_asset")}
          </NavLink>
        </div>
      )}
    </header>
  );
}
